import React from "react";
import { UserMenu, MenuItemLink } from "react-admin";

import FaceIcon from '@material-ui/icons/Face';

const MyUserMenu = (props) => {

	return (
		<UserMenu {...props}>
		<MenuItemLink
			to="/profile"
			primaryText="My Profile"
			leftIcon={<FaceIcon />}
		/>
		</UserMenu>
	);
};

export default MyUserMenu;
